<template>
  <bk-popup
    class="depositPolicyPopup"
    :show="show"
    :footerInfo="footerInfo"
    @close="close"
  >
    <bk-view class="view-policy-list">
      <!-- <bk-view class="view-policy-item" v-if="depositConfig.depositRule">
        <bk-lang class="view-title" code="reserve_deposit_depositPolicy"></bk-lang>
        <bk-view class="view-info">{{depositConfig.depositRule}}</bk-view>
      </bk-view> -->
        <bk-view class="view-policy-item" v-if="depositConfig.cancelRule">
        <bk-lang class="view-title" code="reserve_deposit_cancellationPolicy"></bk-lang>
        <bk-view class="view-info">{{depositConfig.cancelRule}}</bk-view>
      </bk-view>
        <bk-view class="view-policy-item" v-if="depositConfig.termsConditions">
        <bk-lang class="view-title" code="reserve_deposit_termsandConditions"></bk-lang>
        <bk-view class="view-info">{{depositConfig.termsConditions}}</bk-view>
      </bk-view>
    </bk-view>
  </bk-popup>
</template>

<script>
	import { reserveReq } from '@/reqService';


	export default {
		name:'depositPolicy',
		props:{
			show:Boolean,
			resDetail:Object,
		},
		data (){
			return {
				footerInfo:{ show: false },
				depositConfig:{},
			};
		},
		watch:{
			show (val){
				if(val){
					this.initData();
				}
			}
		},
		methods:{
			close (){
				this.$emit('close');
			},
			initData (){
				this.requestPostdepositConfig();
			},
			// 查询预定金配置
			async requestPostdepositConfig (){
				const { custId, compId } = this.resDetail;
				let res = await reserveReq.requestPostdepositConfig(this, { custId, compId});
				this.depositConfig = res;
			},
		}
	};
</script>

<style lang="less">
@import './depositPolicy.less';
</style> 